module.exports = __webpack_public_path__ + "img/img-8.44454df1.png";